export const BOOKING_OPTION_SELECT_TABS: { [name: string]: PLTab } = {
	mediaServices: { value: 'mediaServices', text: 'Media services', highlight: false },
	editingServices: { value: 'editingServices', text: 'Editing services', highlight: false }
};
